import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/common";
import DocumentsList from "@/components/DocumentsList";

export default function ClientDocuments({ clientId, pages }) {
  const [items, setItems] = useState([]);
  const [pageId, setPageId] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [inputKey, setInputKey] = useState(0);
  const load = () => api.get(`/admin/clients/${clientId}/documents`).then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps
  const docPages = pages.filter((p) => p.show_documents);

  const upload = async (e) => {
    e.preventDefault();
    if (!pageId || !file) return toast.error("Seleziona pagina e file");
    const fd = new FormData();
    fd.append("client_id", clientId);
    fd.append("page_id", pageId);
    fd.append("title", title);
    fd.append("file", file);
    setBusy(true);
    try {
      await api.post("/admin/documents", fd);
      toast.success("Documento caricato");
      setTitle("");
      setFile(null);
      setInputKey((k) => k + 1);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const remove = async (d) => {
    if (!window.confirm(`Eliminare "${d.title}"?`)) return;
    await api.delete(`/admin/documents/${d.id}`);
    toast.success("Documento eliminato");
    load();
  };
  return (
    <div className="space-y-6">
      <Panel title="Carica documento">
        <form onSubmit={upload} className="p-5 grid lg:grid-cols-[200px_1fr_1fr_auto] gap-3">
          <Select value={pageId} onValueChange={setPageId}>
            <SelectTrigger data-testid="doc-page-select"><SelectValue placeholder="Pagina" /></SelectTrigger>
            <SelectContent>{docPages.map((p) => <SelectItem key={p.id} value={p.id}>{p.title}</SelectItem>)}</SelectContent>
          </Select>
          <Input placeholder="Titolo (es. Fattura n. 402/2026)" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="doc-title-input" />
          <Input key={inputKey} type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} className="file:text-slate-300" data-testid="doc-file-input" />
          <Button type="submit" disabled={busy} className="bg-blue-600 hover:bg-blue-500" data-testid="upload-doc-button">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <><Upload size={15} className="mr-1.5" />Carica</>}
          </Button>
        </form>
      </Panel>
      <Panel title={`Documenti del cliente (${items.length})`}>
        <DocumentsList items={items} pages={pages} onDelete={remove} />
      </Panel>
    </div>
  );
}
